<div class="popup">
    <div class="modal-header" style="text-align:center;">
        <div class="modal-headerTitle" style="padding-left:10px;padding-top:10px; color:red; width:100%;">WARNING - Additional Teacher</div>
    </div>
    <div class="modal-body" style="padding:10px;margin-bottom:70px;">
        <div *ngIf="additionalTeacher" style="padding-top:10px; padding-left:10px;">
            You are an additional teacher for <span *ngIf="multipleAdditional">some classes</span><span *ngIf="singleAdditional">a class</span>. Only the primary teacher is able to make changes to the preferences for a class.
        </div>
        <div *ngIf="additionalTeacher && syncPreferencesAcrossCourses" style="padding-top:10px; padding-left:10px;">
            Changes you make will apply only to the classes for which you are not an additional teacher.
        </div>
        <div *ngIf="additionalTeacher && !syncPreferencesAcrossCourses" style="padding-top:10px; padding-left:10px;">
            The <i>Show Preferences For</i> dropdown at the top of the page only lists classes for which you are not an additional teacher.
        </div>
        <div *ngIf="additionalTeacherClassFocus" style="padding-top:10px; padding-left:10px; font-weight:bold;">
            Note that the class selected in the dropdown is NOT the current class.
        </div>
    </div>    
    <div class="sis-app-footer">
            <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()" style="float:right"></tyl-button>
    </div>
</div>
    